import React, { Suspense } from 'react';

import { App as CVTApp } from '@cvt/App';
import ErrorBoundary from '@cvt/components/ErrorBoundary';
import { BodyLoading } from '@cvt/components/layout/BodyLoading';

import { AuthProvider } from '@modules/Auth/contexts';
import { UserProvider } from '@modules/Users/contexts';
import { FunFactProvider } from '@modules/Assertions/contexts/FunFactContext/FunFactContext';

import { LayoutProvider } from '@shared/contexts/LayoutContext';
import { MainLayout } from '@shared/components/layouts/MainLayout';
import { Dialogs } from '@shared/components/Dialogs';
import { InstallPrompt } from '@shared/components/InstallPrompt';

import { Root } from '@pages/Root';

const App = () => {
  return (
    <CVTApp>
      <ErrorBoundary>
        <InstallPrompt>
          <Suspense fallback={<BodyLoading height="100%"/>}>
            <AuthProvider>
              <UserProvider>
                <LayoutProvider>
                  <FunFactProvider>
                    <MainLayout>
                      <Root />
                      <Dialogs />
                    </MainLayout>
                  </FunFactProvider>
                </LayoutProvider>
              </UserProvider>
            </AuthProvider>
          </Suspense>
        </InstallPrompt>
      </ErrorBoundary>
    </CVTApp>
  );
};

export default App;
